<template>
    <div>
      <BasePopup v-model="isPopupOpen" customClass="custom-popup mx-wd640">
        <div class="popup-header">
          <h3 class="title">유효기간 선택</h3>
          <button type="button" class="btn-cancel" @click="handleClose"></button>
        </div>
        <div class="popup-body">
          <fieldset>
            <legend>유효기간 선택</legend>
            <p class="inp-label fs14 mb20">유효기간</p>
            <div class="form-group row gap30">
              <HconRadioBox label="30일" value="30" v-model="tempValue" name="name" :hide-label="false"/>
              <HconRadioBox label="60일" value="60" v-model="tempValue" name="name" :hide-label="false"/>
              <HconRadioBox label="90일" value="90" v-model="tempValue" name="name" :hide-label="false"/>
            </div>
          </fieldset>
          <div class="box-gray mt40">
            <ul class="dot-list">
              <li>유효기간 30일은 <strong class="text-green">유효기간 60일 및 90일 구간 외 모든 유효기간</strong>이 포함된 구간입니다.</li>
              <li>유효기간 60일은 <strong class="text-green">58~62일</strong>, 유효기간 90일은 <strong class="text-green">89~93일</strong>의 유효기간이 포함된 구간입니다.</li>
              <li>선택한 유효기간의 <strong class="text-green">할인율은 이벤트 할인 혜택 상품에는 적용되지 않습니다.</strong></li>
              <li>유효기간 60일 및 90일 구간 외의 유효기간(예, 배송 상품 7일)은 30일 구간을 선택해 주세요.</li>
              <li>유효기간 설정 변경 시 <strong class="text-green">발송 상품에 담은 상품이 모두 초기화</strong>됩니다.</li>
            </ul>
          </div>
        </div>
        <div class="popup-footer jc-c">
          <div class="button-box">
            <button type="button" @click="expPeriodChangeConfirm" class="btn md">선택 적용</button>
          </div>
        </div>
      </BasePopup>
    </div>
</template>
<script lang="ts" setup>
import HconRadioBox from '@/components/com/HconComPCRadio.vue'
import BasePopup from '@/components/com/HconComBasePopup.vue'

import { usePopup } from '@/composables/hconUsePopup'
import { ORDER_CODE } from "@/constants/hconMessageConstants";

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const { showConfirm } = usePopup() // 팝업
const props = defineProps(['modelValue']) // 부모의 v-model
const emit = defineEmits(['update:modelValue'])
const tempValue = ref(props.modelValue) // 필요 변수 선언
const isPopupOpen = ref(false) // 해당 팝업 오픈여부

// 팝업 닫힘
const handleClose = () => {
  isPopupOpen.value = false
}

// 팝업 열림
const handleOpen = () => {
  isPopupOpen.value = true;
}

const expPeriodChangeConfirm = async () => {
  const result = await showConfirm({
    title: '초기화 안내',
    message: ORDER_CODE.ALT_HCON_9131,
    onConfirm: () => {
      emit('update:modelValue', tempValue.value)
      handleClose()
    }
  })
}

defineExpose({ handleOpen, handleClose });

</script>
<style lang="scss">
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>